import getIn from 'transmute/getIn';
export const getThreadPresence = getIn(['threadPresence']);